import React, { useState } from 'react';
import styled from 'styled-components';

import ConfirmationOverlay from 'shared/ConfirmationOverlay';
import NetsuiteCloseWarning from 'shared/NetsuiteCloseWarning';

const FORM_SELECTOR = 'form[data-cy="complete_greens_form"]';
const SELECTED_ITEMS_SELECTOR = 'input[name^="milling_output["]';

const Acknowledge = styled.label`
  align-items: center;
  display: flex;
  gap: 0.5rem;
  cursor: pointer;
  font-weight: bold;
`;

export interface ConfirmCompleteGreensComponentProps {
  // Hay un ICO huerfano solicitado o en produccion: no se pueden confirmar los completes.
  disabled: boolean;
  // Los completes de este contrato se informan a NetSuite al cerrar la trilla.
  reportsToNetsuite: boolean;
}

// PLA-860: confirma el paso de completes del flujo nuevo. Si se usan excedentes que NetSuite
// recien conocera al cerrar la trilla, exige reconocer la advertencia antes de confirmar.
const ConfirmCompleteGreensComponent: React.FC<ConfirmCompleteGreensComponentProps> = ({
  disabled,
  reportsToNetsuite,
}) => {
  const [showOverlay, setOverlay] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [requiresAcknowledge, setRequiresAcknowledge] = useState(false);
  const [acknowledged, setAcknowledged] = useState(false);

  const findForm = () => document.querySelector(FORM_SELECTOR) as HTMLFormElement | null;

  const handleOpen = () => {
    const form = findForm();
    const hasSelectedItems = !!form?.querySelector(SELECTED_ITEMS_SELECTOR);

    setRequiresAcknowledge(reportsToNetsuite && hasSelectedItems);
    setAcknowledged(false);
    setOverlay(true);
  };

  const handleOnPrimaryClick = () => {
    const form = findForm();
    if (!form) return;

    setSubmitted(true);
    form.requestSubmit();
  };

  return (
    <>
      {showOverlay && (
        <ConfirmationOverlay
          title={I18n.translate('milling_orders.completes.confirmation_title')}
          confirmText={I18n.translate('buttons.confirm')}
          onConfirmClick={handleOnPrimaryClick}
          cancelText={I18n.translate('buttons.cancel')}
          primaryDisabled={submitted || (requiresAcknowledge && !acknowledged)}
          onCancelClick={() => setOverlay(false)}
        >
          {requiresAcknowledge && (
            <>
              <NetsuiteCloseWarning />

              <Acknowledge>
                <input
                  type='checkbox'
                  checked={acknowledged}
                  onChange={(event) => setAcknowledged(event.target.checked)}
                  data-cy='netsuite_close_warning_acknowledge'
                />

                {I18n.translate('milling_orders.netsuite_close_warning.acknowledge')}
              </Acknowledge>
            </>
          )}
        </ConfirmationOverlay>
      )}

      <button
        type='button'
        className='button'
        data-cy='complete_greens_button'
        disabled={disabled}
        onClick={handleOpen}
      >
        {I18n.translate('milling_orders.completes.confirm')}
      </button>
    </>
  );
};

export default ConfirmCompleteGreensComponent;
